import { INode } from 'react-accessible-treeview';

import { Group } from '@app/types/api/group';

export interface GroupNodeData extends INode {
  name: string;
  isBranch?: boolean;
  isLast?: boolean;
  count?: number;
  groupId?: string;
  subgroupCount?: number | string;
  subgroups?: Group[];
  isDefaultSelected?: boolean;
}

export const formatGroupNodes = (groups: Group[] = [], preSelectedGroupId: string | undefined = undefined) => {
  const groupNodes = [];

  const rootNode = {
    name: '',
    id: 0,
    children: groups.map((group) => group?.id || group?._id),
    parent: null,
  };

  groupNodes.push(rootNode);

  for (let i = 0; i < groups.length; i += 1) {
    const group = groups[i];
    const groupNode = {
      id: group?.id || group?._id,
      name: group?.name,
      children: [],
      parent: rootNode.id,
      isBranch: true,
      isLast: i === groups.length - 1,
      count: group?.count,
      subgroupCount: group?.subgroups?.length,
      isDefaultSelected: (group?._id === preSelectedGroupId) || i === 0,
    };
    groupNodes.push(groupNode);
  }
  return groupNodes as GroupNodeData[];
};
